import { ContactLink } from '@features/members/components/MemberOrg';
import Icon, { IconName } from '@features/ui-atoms/components/Icon';
import Tooltip from '@features/ui-atoms/components/Tooltip';
import { styled } from '@mui/joy';
import { useTranslation } from 'next-i18next';

export const PrivateSstBadge = ({ feedbackRequestedFrom }: { feedbackRequestedFrom: string[] }) => {
  const { t } = useTranslation('common');
  if (!feedbackRequestedFrom || feedbackRequestedFrom.length === 0) {
    return null;
  }

  return (
    <BadgeContainer>
      <Tooltip
        title={
          <div style={{ minWidth: 120 }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('sst.privateSstBadge.tooltip')}</div>
            {feedbackRequestedFrom.map((id, idx) => (
              <div key={idx}>
                <ContactLink id={id} color="white" />
              </div>
            ))}
          </div>
        }
      >
        <BadgeIcon>
          <Icon name={IconName.lockedForum} size={18} />
        </BadgeIcon>
      </Tooltip>
    </BadgeContainer>
  );
};

const BadgeContainer = styled('div')(({ theme: { palette } }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: palette.grey1,
  borderRadius: '20px',
  padding: '4px 6px',
  height: '20px',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
}));

const BadgeIcon = styled('div')(({ theme: { palette } }) => ({
  color: palette.grey5,
  display: 'flex',
  alignItems: 'center',
}));
